import ImgTag from "@/components/Helpers/ImgTag";
import PriceV2 from "@/components/Helpers/product-card/PriceV2";
import { validateImgSrc } from "@/utils/global";
import React from "react";

const Info = ({
  item,
  price,
  // t
}) => {
  console.log(item, "item");

  return (
    <div className="flex me-2">
      <div className="h-24 w-32 border rounded-xl">
        <ImgTag
          src={validateImgSrc(
            item?.image ||
              `${process.env.NEXT_PUBLIC_IMAGE_BASEURL}/media/catalog/product/${item?.extension_attributes?.product_image}`
          )}
          className="object-contain p-1 size-full"
          height={100}
          width={100}
          alt="Prod Cart Img!"
        />
      </div>

      <div className="flex flex-col justify-between mx-2 w-full">
        <p className="mb-1 font-semibold text-black text-[15px]">
          {item?.name || "product"}
        </p>

        <PriceV2
          {...{
            discount: price?.discount,
            originalPrice: price?.originalPrice,
            specialPrice: price?.specialPrice,
            fromProductCard: false,
          }}
        />
        {/* {item?.back_orders && (
      <div className="text-[10px] w-fit font-semibold px-2 py-1 text-white bg-blue rounded-full text-center">
        {t("PreOrder")}
      </div>
    )} */}
      </div>
    </div>
  );
};

export default Info;
